import React from "react";
import ContinueButton from "../Buttons/ContinueButton";
import { getPlatform } from "@/lib/iap";
import TitleBox from "../TitleBox";
import { haptic } from "@/lib/haptic";

const emojiOptions = [
  { value: 0, emoji: "😴", label: "Too easy" },
  { value: 1, emoji: "😃", label: "Just right" },
  { value: 2, emoji: "😰", label: "Too hard" },
];

interface QuestionScreenProps {
  onDifficultySelect: (difficulty: number) => void;
  onContinue: () => void;
  name: string;
}

const QuestionScreen: React.FC<QuestionScreenProps> = ({
  onDifficultySelect,
  onContinue,
  name,
}) => {
  const platform = getPlatform();
  const [selectedOption, setSelectedOption] = React.useState<number | null>(
    null
  );

  const handleOptionClick = (value: number) => {
    haptic.soft();
    setSelectedOption(value);
    onDifficultySelect(value);
  };

  return (
    <div className="appPadding py-0 flex flex-col h-full w-full overflow-hidden justify-between">
      <div className="pt-4 px-2 pb-2 w-full">
        <TitleBox
          title={`Great work, ${name}! 🥳`}
          subtitle="The goal is to understand about 80% of the words in the video."
        />
      </div>
      <div className="flex flex-col items-center justify-center w-full gap-3">
        <div className="text-center text-[var(--color-grey)]">
          Rate video difficulty
        </div>
        <div className="bg-white rounded-xl w-full max-w-[600px] flex flex-col items-center justify-center py-6 px-4">
          <div className="flex flex-row gap-8 justify-center w-full">
            {emojiOptions.map((option) => (
              <div
                key={option.value}
                className="flex flex-col items-center gap-2"
              >
                <button
                  className={`w-16 h-16 rounded-full flex items-center justify-center border-2 transition-colors text-4xl ${
                    selectedOption === option.value
                      ? "bg-[var(--color-blue)] text-white border-[var(--color-blue)]"
                      : "bg-[var(--color-grey-lightest)] text-[var(--color-grey)] border-[var(--color-grey-lightest)] hover:border-[var(--color-blue)]"
                  }`}
                  onClick={() => handleOptionClick(option.value)}
                  aria-label={option.label}
                >
                  <span className="text-4xl">{option.emoji}</span>
                </button>
                <span className="text-xs text-center text-gray-500 w-16">
                  {option.label}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div
        className={`flex justify-center items-center ${
          platform === "web" ? "bottom-padding-web" : "pb-6"
        }`}
      >
        <ContinueButton
          onClick={onContinue}
          text="Continue"
          disabled={selectedOption === null}
        />
      </div>
    </div>
  );
};

export default QuestionScreen;
